export const getDisplayName = (categoryName: string) =>
  `${categoryName === 'all' ? 'Tümü' : categoryName}`;

export const getDisplayText = (categoryName: string, numberOfImages: number) =>
  `${getDisplayName(categoryName)} (${numberOfImages})`;
